/**
 * Backend `SimilarHtsSuggestionScope` — where `GET companies/{id}/similar-hts-suggestions` looks (#13534). Sent by name:
 * `Catalog` (the default when omitted) searches the assistant-backed catalog items only; `All` searches the same sources as
 * the line endpoint (catalog, lines verified by the assistant or the catalog, lines of released entries).
 */
export enum enumSimilarHtsSuggestionScope {
  Catalog = 'catalog',
  All = 'all',
}
